import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

export interface QandABoxProps {
  values: Record<string, string>;
  questionSpacing?: number | undefined;
  answerSpacing: number;
}

function QandABox({ values, questionSpacing, answerSpacing }: QandABoxProps) {
  const { q: question, ...answers } = values;
  questionSpacing ??= 30;

  // if (typeof answerSpacing === 'undefined') {
  //   answerSpacing = (answerSpacing ?? 30);
  // }
  // console.log(answerSpacing);
  // console.log(questionSpacing);

  // Get the greater spacing value and add 20 to it to account for the left margin
  // We use the right margin to make certain that all questions and answers fit within the QandABox
  const rightMargin = ((answerSpacing > questionSpacing) ? answerSpacing : questionSpacing ) + 20;

  return (
    <Paper>
      {/* the answering spacing tends to b */}
      <Stack textAlign="start" m={2} marginRight={`${rightMargin}px`}>
        <Box
          sx={{
            position: "relative",
            fontWeight: 'bold',
            left: questionSpacing,

            "::before": {
              fontWeight: "bold",
              content: `'${"Q"}: '`,
              width: 0,
              height: 0,

              left: -questionSpacing,
              position: "absolute",
            },
          }}
        >
          {question}
        </Box>

        {Object.entries(answers).map(([key, value]) =>
          value && value !== "" ? (
            <Box
              marginTop={1}
              key={key}
              sx={{
                position: "relative",
                left: answerSpacing,
                
                

                "::before": {
                  fontWeight: "bold",
                  content: `'${key[0].toUpperCase()}${key.slice(1)}: '`,
                  width: 0,
                  height: 0,

                  left: -answerSpacing,
                  position: "absolute",
                },
              }}
            >
              {value}
            </Box>
          ) : null
        )}
      </Stack>
    </Paper>
  );
}

export default QandABox;
